export default "__VITE_ASSET__B312cu1C__"